import { render, staticRenderFns } from "./Canvases.vue?vue&type=template&id=44c86020&"
import script from "./Canvases.vue?vue&type=script&lang=js&"
export * from "./Canvases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports